import * as React from 'react'

const MOBILE_BREAKPOINT = 768

export function useIsMobile(breakpoint: number = MOBILE_BREAKPOINT) {
  // Subscribe to the media query directly via useSyncExternalStore (React's recommended
  // pattern for external stores) instead of an effect that setStates on mount + change.
  // Server snapshot is `false`, matching the previous `!!isMobile` initial value.
  const subscribe = React.useCallback(
    (onChange: () => void) => {
      const mql = window.matchMedia(`(max-width: ${breakpoint - 1}px)`)
      mql.addEventListener('change', onChange)
      return () => mql.removeEventListener('change', onChange)
    },
    [breakpoint],
  )

  return React.useSyncExternalStore(
    subscribe,
    () => window.innerWidth < breakpoint,
    () => false,
  )
}
